import React from "react";
import { Component } from "puzzle";
import { Keys } from "@progress/kendo-react-common";

function FocusControl(Popup: any) {
  return class extends Component<any, any> {

    /**
     * Attach keyDown Listener to last input or to all buttons in toolbar, used for returning focus to popup.
     */
    attachKeyDown = (component: HTMLDivElement | null) => {
      const domNode = component;
      if (domNode) {
        let focusable = [...domNode.querySelectorAll("button")] as HTMLElement[];
        let length = focusable.length;
        if (length) {
          let focusableElement = focusable[length - 1];
          focusableElement.addEventListener('keydown', this.focusHandler.bind(this, domNode));
        }
      }
    };

    /**
     * Keeps focus with in popup
     * @param domNode
     * @param e
     */
    focusHandler = (domNode: HTMLDivElement, e: KeyboardEvent) => {
      if (domNode && e.keyCode === Keys.tab && !e.shiftKey) {
        e.preventDefault();
        domNode.focus();
      }
    };

    /**
     * Returns focus to popup
     * @param domNode
     * @param e
     */
    preserveFocusOnPopup = (domNode: HTMLDivElement | null, e: React.KeyboardEvent) => {
      const me: any = domNode;
      if (domNode && e.keyCode === Keys.tab && me.isSameNode(e.target)) {
        let focusable = [...me.querySelectorAll("[tabindex='0']")] as HTMLElement[];
        let length = focusable.length;

        if (!length) {
          focusable = [...me.querySelectorAll("input")];
          length = focusable.filter((item) => !item.hasAttribute('disabled')).length;
        }

        if (e.shiftKey) {
          let focusableElement = focusable[length - 1];
          e.preventDefault();
          focusableElement ? focusableElement.focus() : me.focus();
        } else if (!length) {
          e.preventDefault();
          me.focus();
        }
      }
    };

    focusControl = {
      attachKeyDown: this.attachKeyDown,
      preserveFocusOnPopup: this.preserveFocusOnPopup,
    };

    render() {
      return (
        <Popup
          {...this.props}
          focusControl={this.focusControl}
        />
      )
    }
  }
}

export default FocusControl;
